'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CodeBlock, Pre } from '../components/codeblock';
import { PrerenderScript, useShiki } from 'fumadocs-core/utils/use-shiki';
import { useId } from 'react';
import { cn } from '../utils/cn';
const components = {
    pre(props) {
        return (_jsx(CodeBlock, { ...props, className: cn('my-0', props.className), children: _jsx(Pre, { children: props.children }) }));
    },
};
export function DynamicCodeBlock({ lang, code, options, }) {
    const scriptKey = useId();
    const shikiOptions = {
        lang,
        scriptKey,
        ...options,
        components: {
            ...components,
            ...options?.components,
        },
    };
    const children = useShiki(code, shikiOptions);
    return (_jsxs(_Fragment, { children: [_jsx(PrerenderScript, { scriptKey: scriptKey, code: code, options: shikiOptions }), children] }));
}
